/** @format */

// JavaScript

// -----------------------------
// デバイス幅が375px未満の場合、表示を375px固定で縮小表示するスクリプト
// -----------------------------
(() => {
	const viewport = document.querySelector('meta[name="viewport"]');
	const thresholdWidth = 375; // 閾値の設定

	function setViewport() {
		const content = window.outerWidth >= thresholdWidth ? "width=device-width,initial-scale=1" : `width=${thresholdWidth}`;
		if (viewport.getAttribute("content") !== content) {
			viewport.setAttribute("content", content);
		}
	}

	window.addEventListener("resize", setViewport); // リサイズ時の処理
	setViewport(); // 初期設定
})();

// -----------------------------
// メニューのスクリプト
// -----------------------------
const toggleMenu = () => {
	const menuToggle = document.querySelector("[data-nav-toggle]");
	const menu = document.querySelector("[data-nav]");
	const body = document.body;

	if (!menuToggle || !menu) return;

	menuToggle.addEventListener("click", () => {
		const isOpen = menuToggle.getAttribute("aria-expanded") === "true";

		menu.setAttribute("data-nav-state", isOpen ? "closed" : "open");
		menuToggle.setAttribute("aria-expanded", !isOpen);
		body.setAttribute("data-scroll-lock", !isOpen);
	});
};

toggleMenu();

// -----------------------------
// サブメニューの開閉
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
	const menuItems = document.querySelectorAll(".main-nav__item");
	const mediaQuery = window.matchMedia("(max-width: 1024px)");

	// 各メニュー項目のイベントリスナーを保存する配列
	const eventListeners = new Map();

	// サブメニューの開閉を切り替える関数
	function toggleSubmenu(item, button, list) {
		const currentState = item.getAttribute("data-menu-state");
		const newState = currentState === "closed" ? "opened" : "closed";

		if (newState === "opened") {
			openSubmenu(item, button, list);
		} else {
			closeSubmenu(item, button, list);
		}
	}

	// サブメニューを開く関数
	function openSubmenu(item, button, list) {
		item.setAttribute("data-menu-state", "opened");
		button.setAttribute("aria-expanded", "true");
	}

	// サブメニューを閉じる関数
	function closeSubmenu(item, button, list) {
		item.setAttribute("data-menu-state", "closed");
		button.setAttribute("aria-expanded", "false");
	}

	// イベントリスナーを設定する関数
	function setupEventListeners(isMobile) {
		menuItems.forEach((item) => {
			const childButton = item.querySelector(".main-nav__child-button");
			const childList = item.querySelector(".main-nav__child-list");

			// サブメニューがある項目のみ処理
			if (!childButton || !childList) return;

			// 既存のイベントリスナーを削除
			const existingListeners = eventListeners.get(item);
			if (existingListeners) {
				if (existingListeners.mouseenter) {
					item.removeEventListener("mouseenter", existingListeners.mouseenter);
				}
				if (existingListeners.mouseleave) {
					item.removeEventListener("mouseleave", existingListeners.mouseleave);
				}
			}

			// 初期状態を設定
			item.setAttribute("data-menu-state", "closed");
			childButton.setAttribute("aria-expanded", "false");

			// クリックイベント（常に設定）
			if (!existingListeners || !existingListeners.click) {
				const clickHandler = function (e) {
					e.preventDefault();
					e.stopPropagation();
					toggleSubmenu(item, childButton, childList);
				};
				childButton.addEventListener("click", clickHandler);

				if (!eventListeners.has(item)) {
					eventListeners.set(item, {});
				}
				eventListeners.get(item).click = clickHandler;
			}

			// PCでのホバーイベント
			if (!isMobile) {
				let hoverTimeout;

				const mouseenterHandler = function () {
					clearTimeout(hoverTimeout);
					openSubmenu(item, childButton, childList);
				};

				const mouseleaveHandler = function () {
					hoverTimeout = setTimeout(() => {
						closeSubmenu(item, childButton, childList);
					}, 100);
				};

				item.addEventListener("mouseenter", mouseenterHandler);
				item.addEventListener("mouseleave", mouseleaveHandler);

				// イベントリスナーを保存
				eventListeners.get(item).mouseenter = mouseenterHandler;
				eventListeners.get(item).mouseleave = mouseleaveHandler;
			}
		});
	}

	// 初期設定
	setupEventListeners(mediaQuery.matches);

	// メディアクエリの変更を監視
	mediaQuery.addEventListener("change", function (e) {
		setupEventListeners(e.matches);
	});
});

// -----------------------------
// フッターナビゲーション（スマホ用）のサブメニュー開閉
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
	const footerMenuItems = document.querySelectorAll(".site-footer__nav-mobile-item");
	const mediaQuery = window.matchMedia("(max-width: 1024px)");

	// 各メニュー項目のイベントリスナーを保存する配列
	const footerEventListeners = new Map();

	// サブメニューの開閉を切り替える関数
	function toggleFooterSubmenu(item, button, list) {
		const currentState = item.getAttribute("data-menu-state");
		const newState = currentState === "closed" ? "opened" : "closed";

		if (newState === "opened") {
			openFooterSubmenu(item, button, list);
		} else {
			closeFooterSubmenu(item, button, list);
		}
	}

	// サブメニューを開く関数
	function openFooterSubmenu(item, button, list) {
		item.setAttribute("data-menu-state", "opened");
		button.setAttribute("aria-expanded", "true");
	}

	// サブメニューを閉じる関数
	function closeFooterSubmenu(item, button, list) {
		item.setAttribute("data-menu-state", "closed");
		button.setAttribute("aria-expanded", "false");
	}

	// イベントリスナーを設定する関数
	function setupFooterEventListeners(isMobile) {
		console.log("Footer menu items found:", footerMenuItems.length);
		footerMenuItems.forEach((item, index) => {
			const childButton = item.querySelector(".site-footer__nav-mobile-child-button");
			const childList = item.querySelector(".site-footer__nav-mobile-child-list");

			console.log(`Item ${index}:`, { childButton: !!childButton, childList: !!childList });

			// サブメニューがある項目のみ処理
			if (!childButton || !childList) return;

			// 既存のイベントリスナーを削除
			const existingListeners = footerEventListeners.get(item);
			if (existingListeners) {
				if (existingListeners.click) {
					childButton.removeEventListener("click", existingListeners.click);
				}
			}

			// 初期状態を設定
			item.setAttribute("data-menu-state", "closed");
			childButton.setAttribute("aria-expanded", "false");

			// クリックイベント（スマホでのみ設定）
			if (isMobile) {
				if (!existingListeners || !existingListeners.click) {
					const clickHandler = function (e) {
						console.log("Footer submenu button clicked");
						e.preventDefault();
						e.stopPropagation();
						toggleFooterSubmenu(item, childButton, childList);
					};
					childButton.addEventListener("click", clickHandler);

					if (!footerEventListeners.has(item)) {
						footerEventListeners.set(item, {});
					}
					footerEventListeners.get(item).click = clickHandler;
				}
			}
		});
	}

	// 初期設定
	setupFooterEventListeners(mediaQuery.matches);

	// メディアクエリの変更を監視
	mediaQuery.addEventListener("change", function (e) {
		setupFooterEventListeners(e.matches);
	});
});

// -----------------------------
// Splide
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
	// 各Splideスライダーの初期化前に、対象要素の存在を確認する

	// 基本的なスライダー
	const basicSlider = document.querySelector(".splide-news");
	if (basicSlider) {
		new Splide(".splide-news", {
			type: "loop",
			perPage: 3,
			perMove: 1,
			gap: 24,
			speed: 1000,
			autoplay: "pause",
			interval: 3000,
			pauseOnHover: true,
			pagination: false,
			arrows: true,
			intersection: {
				inView: {
					autoplay: true,
				},
				outView: {
					autoplay: false,
				},
			},
		}).mount({ Intersection: window.splide.Extensions.Intersection });
	}

	// メインビジュアルスライダー
	const mvSlider = document.querySelector(".splide-mv");
	const thumbnailSlider = document.querySelector(".splide-mv-thumbnails");

	if (mvSlider && thumbnailSlider) {
		// メインスライダーの初期化
		const main = new Splide(".splide-mv", {
			type: "loop",
			fixedWidth: "min(100%, 848px)",
			perPage: 1,
			focus: "center",
			padding: { left: "20%", right: "20%" },
			gap: "1.11vw",
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
			speed: 1000,
			pagination: false,
			breakpoints: {
				768: {
					pagination: true,
					arrows: false,
					padding: { left: "10%", right: "10%" },
					gap: 16,
				},
			},
		});

		// サムネイルスライダーの初期化
		const thumbnails = new Splide(".splide-mv-thumbnails", {
			//fixedWidth: "11.1vw",
			perPage: 6,
			gap: "1.11vw",
			rewind: true,
			pagination: false,
			arrows: false,
			isNavigation: true,
		});

		// サムネイルとメインスライダーの同期
		main.sync(thumbnails);
		main.mount();
		thumbnails.mount();
	}

	// Home Industry Slider（業種別スライダー）
	const industrySlider = document.getElementById("home-industry-slider");
	if (industrySlider) {
		new Splide("#home-industry-slider", {
			type: "loop",
			perPage: 1,
			perMove: 1,
			gap: "2rem",
			autoplay: true,
			interval: 5000,
			pauseOnHover: true,
			pauseOnFocus: true,
			pagination: true,
			breakpoints: {
				768: {
					gap: "1rem",
					arrows: false,
				},
			},
		}).mount();
	}

	// Voices Slider（お客様の声スライダー）
	const voicesSlider = document.getElementById("voices-slider");
	if (voicesSlider) {
		new Splide("#voices-slider", {
			type: "slide",
			rewind: true,
			perPage: 4,
			perMove: 1,
			gap: "1.6666vw",
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
			speed: 1000,
			pagination: false,
			arrows: true,
			breakpoints: {
				1024: {
					perPage: 3,
				},
				768: {
					perPage: 1,
					padding: { left: "12%", right: "12%" },
					gap: 16,
					arrows: false,
				},
			},
		}).mount();
	}

	// FAQ Slider（FAQスライダー）
	const faqSlider = document.getElementById("faq-slider");
	if (faqSlider) {
		const splideInstance = new Splide("#faq-slider", {
			type: "loop",
			perPage: 3,
			padding: { left: "12.5%", right: "12.5%" },
			perMove: 1,
			gap: "1.6666vw",
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
			speed: 1000,
			pagination: false,
			arrows: true,
			breakpoints: {
				1024: {
					perPage: 3,
					padding: { left: "0", right: "0" },
				},
				768: {
					// スマホではスライダーを破棄
					destroy: true,
				},
			},
		}).mount();
	}

	// Interview Slider（社員インタビュースライダー）
	const interviewSlider = document.getElementById("interview-slider");
	if (interviewSlider) {
		const splideInstance = new Splide("#interview-slider", {
			type: "slide",
			rewind: true,
			perPage: 3,
			padding: { left: "12.5%", right: "12.5%" },
			perMove: 1,
			gap: "2.2222vw",
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
			speed: 1000,
			pagination: false,
			arrows: true,
			dragMinThreshold: {
				mouse: 0,
				touch: 40,
			},
			breakpoints: {
				1024: {
					padding: { left: "0%", right: "0%" },
				},
				800: {
					perPage: 1,
					padding: { left: "18%", right: "18%" },
					gap: 16,
				},
			},
		}).mount();
	}

	// Product Gallery Slider（商品画像カルーセル）
	const productMainSlider = document.querySelector(".products-slider__main");
	const productThumbnailSlider = document.querySelector(".products-slider__thumbnails");

	if (productMainSlider && productThumbnailSlider) {
		// メインカルーセルの初期化
		const main = new Splide(".products-slider__main", {
			type: "fade",
			perPage: 1,
			pagination: false,
			arrows: false,
			speed: 600,
		});

		// サムネイルカルーセルの初期化
		const thumbnails = new Splide(".products-slider__thumbnails", {
			perPage: 5,
			pagination: false,
			arrows: true,
			gap: "8px",
			rewind: true,
			speed: 600,
			isNavigation: true,
			breakpoints: {
				768: {
					perPage: 4,
				},
			},
		});

		// メインカルーセルとサムネイルカルーセルの同期
		main.sync(thumbnails);
		main.mount();
		thumbnails.mount();
	}

	// 無限ループカルーセルの初期化
	const carouselSlider = document.querySelector(".recruit-home-lead__slider");
	if (carouselSlider) {
		const splide = new Splide(".recruit-home-lead__slider", {
			type: "loop",
			perPage: 3,
			arrows: false,
			pagination: false,
			padding: { left: "10%", right: "10%" },
			drag: "free",
			gap: "3.3333vw",
			focus: "center",
			autoScroll: {
				speed: 0.5,
				pauseOnHover: false,
				autoStart: false,
			},
			breakpoints: {
				1024: {
					perPage: 2,
					gap: 24,
					padding: { left: "24%", right: "24%" },
				},
				768: {
					perPage: 1,
				},
			},
		});

		// スライダーの状態管理
		splide.on("mounted", () => {
			splide.Components.AutoScroll.pause();
		});
		splide.on("intersection:in", () => {
			splide.Components.AutoScroll.play();
		});
		splide.on("intersection:out", () => {
			splide.Components.AutoScroll.pause();
		});

		splide.mount({
			AutoScroll: window.splide.Extensions.AutoScroll,
			Intersection: window.splide.Extensions.Intersection,
		});
	}
});

/**
 * # スクロールイベントで要素の状態を変更
 * @description スクロール位置に応じて要素の状態を変更する機能
 * @type {Object}
 * @example
 * <!-- カスタムしきい値を持つ要素 -->
 * <div data-state="default" data-scroll-threshold="800px">
 *   <!-- 状態を変更したい要素 -->
 * </div>
 * <!-- デフォルトしきい値を使用する要素 -->
 * <div data-state="default">
 *   <!-- 状態を変更したい要素 -->
 * </div>
 */

// ! デフォルトのスクロールしきい値（ピクセル単位）
let DEFAULT_SCROLL_THRESHOLD = 100;

// * スクロール位置による状態変更の監視
window.addEventListener("scroll", function () {
	const scrollPosition = window.scrollY;
	const elements = document.querySelectorAll("[data-state]");

	elements.forEach((element) => {
		const threshold = parseThreshold(element.dataset.scrollThreshold);
		const currentState = element.dataset.state;

		if (scrollPosition > threshold && currentState !== "active") {
			element.dataset.state = "active";
		} else if (scrollPosition <= threshold && currentState !== "default") {
			element.dataset.state = "default";
		}
	});
});

/**
 * @description スクロールしきい値を解析する関数
 * @param {string|undefined} value スクロールしきい値（例: "800px"）
 * @return {number} ピクセル単位のしきい値
 */
function parseThreshold(value) {
	if (typeof value !== "string") return DEFAULT_SCROLL_THRESHOLD;

	const match = value.match(/^(\d+)(px|vh|%)$/);
	if (!match) return DEFAULT_SCROLL_THRESHOLD;

	const num = parseInt(match[1], 10);
	const unit = match[2];

	switch (unit) {
		case "px":
			return num;
		case "vh":
			return (num / 100) * window.innerHeight;
		case "%":
			return (num / 100) * document.documentElement.scrollHeight;
		default:
			return DEFAULT_SCROLL_THRESHOLD;
	}
}

// ? デフォルトのしきい値の変更例
// DEFAULT_SCROLL_THRESHOLD = 200;

// -----------------------------
// スクロール連動アニメーションをオブサーバーする関数
// -----------------------------
// IntersectionObserverのデフォルトオプション設定
const defaultOptions = {
	root: null, // ビューポートを監視対象とする
	rootMargin: "0px", // 監視範囲のマージン
	threshold: 0, // 要素が少しでも表示されたらコールバックを実行
	stopOnComplete: true, // すべての要素がアニメーションしたら監視を停止するかどうか
};

// アニメーションの初期化関数
const initializeObserveAnimation = (targets, options = {}) => {
	const targetsLength = targets.length;
	if (targetsLength === 0) {
		console.error("initializeObserveAnimation: Target elements are not found.");
		return;
	}

	// ユーザーオプションとデフォルトオプションをマージ
	const mergedOptions = { ...defaultOptions, ...options };

	// IntersectionObserverの作成
	const observer = createObserver(mergedOptions, targetsLength);

	// 各ターゲット要素の監視を開始
	targets.forEach((target) => observer.observe(target));
};

// IntersectionObserverを作成する関数
const createObserver = (options, targetsLength) => {
	let observer; // IntersectionObserverのインスタンス
	let activeCount = 0; // アニメーションが完了した要素のカウント

	// IntersectionObserverのコールバック関数
	const handleObserve = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// 要素が表示されたらdata-animated属性をtrueに設定
				entry.target.setAttribute("data-animated", "true");

				if (options.stopOnComplete) {
					// 監視を停止
					observer.unobserve(entry.target);
					activeCount++;
				}
			} else if (!options.stopOnComplete) {
				// 要素が画面外に出たらdata-animated属性をfalseに設定
				entry.target.setAttribute("data-animated", "false");
			}
		});

		// すべての要素がアニメーションしたら監視を停止
		if (options.stopOnComplete && activeCount === targetsLength) {
			observer.disconnect();
		}
	};

	// IntersectionObserverのインスタンスを作成
	observer = new IntersectionObserver(handleObserve, options);
	return observer;
};

/**
 * スクロールアニメーションの初期化
 * @description DOMContentLoadedイベントで各種スクロールアニメーションを初期化します。
 */
document.addEventListener("DOMContentLoaded", () => {
	// アニメーションの設定
	const animations = [
		{
			type: "page-fade-in",
			options: {
				rootMargin: "0% 0px",
				threshold: 0,
				stopOnComplete: true,
			},
		},
		{
			type: "fade-in",
			options: {
				rootMargin: "0% 0px",
				threshold: 0.3,
				stopOnComplete: true,
			},
		},
		{
			type: "fade-in-up",
			options: {
				rootMargin: "0% 0px",
				threshold: 0.3,
				stopOnComplete: true,
			},
		},
		{
			type: "page-title",
			options: {
				rootMargin: "0% 0px",
				threshold: 0,
				stopOnComplete: true,
			},
		},
		{
			type: "custom",
			options: {
				rootMargin: "0% 0px",
				threshold: 0,
				stopOnComplete: true,
			},
		},
		{
			type: "custom-loop",
			options: {
				rootMargin: "0% 0px",
				threshold: 0,
				stopOnComplete: false,
			},
		},
	];

	// 各アニメーションタイプに対して初期化を実行
	animations.forEach(({ type, options }) => {
		const elements = document.querySelectorAll(`[data-scroll-animation='${type}']`);
		if (elements.length > 0) {
			initializeObserveAnimation(elements, options);
		}
	});
});

/* --------------------------------------------------------------
 # タブ機能
-------------------------------------------------------------- */

/**
 * @description WAI-ARIA 1.2に準拠したアクセシブルなタブUIを実装
 * @type {Function}
 * @example
 * <!-- タブコンテナ -->
 * <div data-tab-container>
 *   <!-- タブリスト -->
 *   <div role="tablist" aria-label="タブグループ名" aria-orientation="horizontal">
 *     <button
 *       id="tab-1"
 *       role="tab"
 *       aria-selected="true"
 *       aria-controls="panel-1"
 *       data-tab-trigger>
 *       タブ1
 *     </button>
 *   </div>
 *   <!-- タブパネル -->
 *   <div
 *     id="panel-1"
 *     role="tabpanel"
 *     aria-labelledby="tab-1"
 *     tabindex="0"
 *     data-tab-content
 *     data-active="true">
 *     パネル1の内容
 *   </div>
 * </div>
 */

/**
 * @description タブの初期化と制御を行う関数
 * @return {void} なし
 */
const initializeTabs = () => {
	const tabContainers = document.querySelectorAll("[data-tab-container]");

	tabContainers.forEach((container) => {
		const tabList = container.querySelector('[role="tablist"]');
		const tabs = container.querySelectorAll('[role="tab"]');
		const panels = container.querySelectorAll('[role="tabpanel"]');

		// * 初期状態の設定
		setInitialState(tabs, panels);

		// * タブのクリックイベント設定
		tabs.forEach((tab, index) => {
			tab.addEventListener("click", () => {
				activateTab(tabs, panels, index);
			});

			// * キーボードナビゲーションの設定
			tab.addEventListener("keydown", (e) => {
				const orientation = tabList?.getAttribute("aria-orientation") || "horizontal";
				handleKeyNavigation(e, tabs, panels, index, orientation);
			});
		});
	});
};

/**
 * @description タブの初期状態を設定する関数
 * @param {NodeList} tabs タブ要素のリスト
 * @param {NodeList} panels パネル要素のリスト
 * @return {void} なし
 */
const setInitialState = (tabs, panels) => {
	tabs.forEach((tab, index) => {
		// ! WAI-ARIA属性の設定
		tab.setAttribute("aria-selected", index === 0 ? "true" : "false");
		tab.setAttribute("tabindex", index === 0 ? "0" : "-1");

		// * パネルとの関連付け
		const panel = panels[index];
		if (panel) {
			const tabId = tab.id || `tab-${index}`;
			const panelId = panel.id || `panel-${index}`;

			tab.id = tabId;
			panel.id = panelId;
			tab.setAttribute("aria-controls", panelId);
			panel.setAttribute("aria-labelledby", tabId);
		}
	});

	// * パネルの初期状態設定
	panels.forEach((panel, index) => {
		panel.setAttribute("data-active", index === 0 ? "true" : "false");
		panel.setAttribute("tabindex", "0");
	});
};

/**
 * @description タブをアクティブ化する関数
 * @param {NodeList} tabs タブ要素のリスト
 * @param {NodeList} panels パネル要素のリスト
 * @param {number} activeIndex アクティブにするタブのインデックス
 * @return {void} なし
 */
const activateTab = (tabs, panels, activeIndex) => {
	tabs.forEach((tab, index) => {
		const isActive = index === activeIndex;
		// ! アクセシビリティ状態の更新
		tab.setAttribute("aria-selected", isActive.toString());
		tab.setAttribute("tabindex", isActive ? "0" : "-1");
	});

	panels.forEach((panel, index) => {
		panel.dataset.active = (index === activeIndex).toString();
	});

	// * アクティブなタブにフォーカス
	tabs[activeIndex].focus();
};

/**
 * @description キーボードナビゲーションを処理する関数
 * @param {KeyboardEvent} event キーボードイベント
 * @param {NodeList} tabs タブ要素のリスト
 * @param {NodeList} panels パネル要素のリスト
 * @param {number} currentIndex 現在のタブのインデックス
 * @param {string} orientation タブの方向（horizontal/vertical）
 * @return {void} なし
 */
const handleKeyNavigation = (event, tabs, panels, currentIndex, orientation) => {
	const isHorizontal = orientation !== "vertical";
	const keyMap = {
		[isHorizontal ? "ArrowLeft" : "ArrowUp"]: () => (currentIndex > 0 ? currentIndex - 1 : tabs.length - 1),
		[isHorizontal ? "ArrowRight" : "ArrowDown"]: () => (currentIndex + 1) % tabs.length,
		Home: () => 0,
		End: () => tabs.length - 1,
	};

	const action = keyMap[event.key];
	if (action) {
		event.preventDefault();
		const newIndex = action();
		activateTab(tabs, panels, newIndex);
	}
};

// * DOMの読み込み完了時にタブを初期化
document.addEventListener("DOMContentLoaded", initializeTabs);

/* --------------------------------------------------------------
# ポップアップ
-------------------------------------------------------------- */

/**
 * @description data属性を使用したポップアップ機能の実装
 * @type {Function}
 * @example
 * <!-- グループ1のポップアップ -->
 * <div data-popup="container" data-popup-group="gallery1">
 *   <button data-popup="trigger" data-target="popup1">開く</button>
 *   <div data-popup="content" data-popup-id="popup1">コンテンツ1</div>
 *   <div data-popup="content" data-popup-id="popup2">コンテンツ2</div>
 *   <button data-popup="prev">前へ</button>
 *   <button data-popup="next">次へ</button>
 *   <button data-popup="close">閉じる</button>
 * </div>
 */

/**
 * @description ポップアップの初期化と制御を行う関数
 * @return {void} なし
 */
const initializePopup = () => {
	const popups = document.querySelectorAll('[data-popup="container"]');
	if (!popups.length) return;

	popups.forEach((popup) => {
		const group = popup.getAttribute("data-popup-group");
		// * グループ属性によるトリガー要素のフィルタリング
		const triggers = group ? document.querySelectorAll(`[data-popup="trigger"][data-group="${group}"]`) : document.querySelectorAll('[data-popup="trigger"]:not([data-group])');
		const contents = popup.querySelectorAll('[data-popup="content"]');
		// 複数のクローズボタンに対応
		const closeBtns = popup.querySelectorAll('[data-popup="close"]');

		// ! 必須要素の存在チェック
		if (!closeBtns.length || triggers.length === 0 || contents.length === 0) return;

		// * オプショナルなナビゲーションボタン
		const prevBtn = popup.querySelector('[data-popup="prev"]');
		const nextBtn = popup.querySelector('[data-popup="next"]');

		let currentIndex = 0;

		/**
		 * @description コンテンツの表示を制御する関数
		 * @param {number} index 表示するコンテンツのインデックス
		 */
		const showContent = (index) => {
			contents.forEach((content, i) => {
				content.setAttribute("data-visible", i === index ? "true" : "false");
			});
			currentIndex = index;
		};

		/**
		 * @description ポップアップを表示する関数
		 * @param {string} targetId 表示するコンテンツのID
		 */
		const showPopup = (targetId) => {
			const index = Array.from(contents).findIndex((content) => content.getAttribute("data-popup-id") === targetId);
			if (index !== -1) {
				showContent(index);
				// ! ポップアップ表示時のスクロール制御
				popup.setAttribute("data-visible", "true");
				document.body.style.overflow = "hidden";
			}
		};

		/**
		 * @description ポップアップを非表示にする関数
		 */
		const hidePopup = () => {
			// ! ポップアップ非表示時のスクロール制御
			popup.setAttribute("data-visible", "false");
			document.body.style.overflow = "auto";
		};

		// * トリガー要素のイベント設定
		triggers.forEach((trigger) => {
			trigger.addEventListener("click", function () {
				const targetId = this.getAttribute("data-target");
				showPopup(targetId);
			});
		});

		// * 閉じるボタンのイベント設定（複数対応）
		closeBtns.forEach((btn) => btn.addEventListener("click", hidePopup));

		// * 外側クリックでの閉じる制御
		popup.addEventListener("click", (event) => {
			if (event.target === popup) {
				hidePopup();
			}
		});

		// * ナビゲーションボタンの制御
		if (prevBtn && nextBtn && contents.length > 1) {
			prevBtn.addEventListener("click", () => {
				const newIndex = (currentIndex - 1 + contents.length) % contents.length;
				showContent(newIndex);
			});

			nextBtn.addEventListener("click", () => {
				const newIndex = (currentIndex + 1) % contents.length;
				showContent(newIndex);
			});
		}
	});
};

// * DOMの読み込み完了時にポップアップを初期化
document.addEventListener("DOMContentLoaded", initializePopup);

/* --------------------------------------------------------------
# アコーディオン
-------------------------------------------------------------- */

/**
 * @usage アコーディオンの設定
 * @type {Object}
 */
const accordionOptions = {
	// ! 排他的動作の制御フラグ
	isExclusive: true,
	// * アコーディオン要素のセレクタ
	selector: "[data-accordion]",
};

/**
 * @description アコーディオンの初期化関数
 * @param {HTMLElement} details アコーディオンの詳細要素
 * @return {void} なし
 */
const initializeDetailsAccordion = (details) => {
	// * 必要な要素の取得
	const summary = details.querySelector("summary");
	const panel = details.querySelector("summary + *");

	// ! 必要な要素が存在しない場合は処理を中断
	if (!(details && summary && panel)) return;

	// * トランジション状態の管理フラグ
	let isTransitioning = false;

	/**
	 * @description アコーディオンを開く処理
	 * @return {void} なし
	 */
	const onOpen = () => {
		// ! 開閉処理の重複を防止
		if (details.open || isTransitioning) return;
		isTransitioning = true;

		// * パネルの開閉アニメーション制御
		panel.style.gridTemplateRows = "0fr";
		details.setAttribute("open", "");

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				panel.style.gridTemplateRows = "1fr";
			});
		});

		// * トランジション完了時の処理
		panel.addEventListener(
			"transitionend",
			() => {
				isTransitioning = false;
			},
			{ once: true },
		);

		// ! 排他的動作時の他パネル制御
		if (accordionOptions.isExclusive) {
			closeOtherAccordions(details);
		}
	};

	/**
	 * @description アコーディオンを閉じる処理
	 * @return {void} なし
	 */
	const onClose = () => {
		// ! 開閉処理の重複を防止
		if (!details.open || isTransitioning) return;
		isTransitioning = true;

		// * パネルの閉じるアニメーション
		panel.style.gridTemplateRows = "0fr";

		// * トランジション完了時の処理
		panel.addEventListener(
			"transitionend",
			() => {
				details.removeAttribute("open");
				panel.style.gridTemplateRows = "";
				isTransitioning = false;
			},
			{ once: true },
		);
	};

	// * 初期状態の設定
	if (details.hasAttribute("open")) {
		panel.style.gridTemplateRows = "1fr";
	}

	// * クリックイベントの制御
	summary.addEventListener("click", (event) => {
		event.preventDefault();
		if (details.open) {
			onClose();
		} else {
			onOpen();
		}
	});
};

/**
 * @description 他のアコーディオンを閉じる関数
 * @param {HTMLElement} currentAccordion 現在開いているアコーディオン
 * @return {void} なし
 */
const closeOtherAccordions = (currentAccordion) => {
	const allAccordions = document.querySelectorAll(accordionOptions.selector);
	allAccordions.forEach((accordion) => {
		if (accordion !== currentAccordion && accordion.hasAttribute("open")) {
			// * 他のアコーディオンを閉じる
			const summary = accordion.querySelector("summary");
			summary.click();
		}
	});
};

// * DOMの読み込み完了時にアコーディオンを初期化
document.addEventListener("DOMContentLoaded", () => {
	const accordions = document.querySelectorAll(accordionOptions.selector);
	accordions.forEach(initializeDetailsAccordion);
});

// -----------------------------
// ニュースカテゴリーフィルタリング機能
// -----------------------------
/**
 * @description ニュースカテゴリーフィルタリング機能を初期化
 * @return {void} なし
 */
const initializeNewsFilter = () => {
	const categoryButtons = document.querySelectorAll(".home-news__category-link");
	const newsItems = document.querySelectorAll(".home-news__item");

	if (categoryButtons.length === 0 || newsItems.length === 0) return;

	categoryButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			e.preventDefault();

			// アクティブ状態の切り替え
			categoryButtons.forEach((btn) => btn.classList.remove("home-news__category-link--active"));
			button.classList.add("home-news__category-link--active");

			// フィルタリング処理
			const selectedCategory = button.dataset.category;
			filterNewsItems(newsItems, selectedCategory);
		});
	});
};

/**
 * @description ニュースアイテムをカテゴリーでフィルタリング
 * @param {NodeList} newsItems ニュースアイテムのリスト
 * @param {string} selectedCategory 選択されたカテゴリーID
 * @return {void} なし
 */
const filterNewsItems = (newsItems, selectedCategory) => {
	newsItems.forEach((item) => {
		const itemCategories = item.dataset.categories;

		if (selectedCategory === "all") {
			// 全て表示
			item.style.display = "";
		} else {
			// 指定カテゴリーのみ表示
			const categoriesArray = itemCategories ? itemCategories.split(",") : [];
			if (categoriesArray.includes(selectedCategory)) {
				item.style.display = "";
			} else {
				item.style.display = "none";
			}
		}
	});
};

// * DOMの読み込み完了時にニュースフィルターを初期化
document.addEventListener("DOMContentLoaded", initializeNewsFilter);
